__turbopack_context__.v({
  "modalActions": "Modal-module__a_--IG__modalActions",
  "modalBackdrop": "Modal-module__a_--IG__modalBackdrop",
  "modalButton": "Modal-module__a_--IG__modalButton",
  "modalContent": "Modal-module__a_--IG__modalContent",
  "modalMessage": "Modal-module__a_--IG__modalMessage",
});
